import {
  GET_BUILDING,
  GetBuildingResponse,
} from 'src/configs/APISchemas/GetBuilding';
import { GraphQLRequest } from 'src/helpers/GraphQLRequest';

export const getBuildingById = async (
  buildingId: string,
): Promise<GetBuildingResponse['building'] | undefined> => {
  const query = GET_BUILDING(buildingId);

  const buildingResponse = await GraphQLRequest<GetBuildingResponse>(query);

  return buildingResponse?.building;
};
